import { render, staticRenderFns } from "./BaseInputFile.vue?vue&type=template&id=569ffb0a&scoped=true"
import script from "./BaseInputFile.vue?vue&type=script&lang=js"
export * from "./BaseInputFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ffb0a",
  null
  
)

export default component.exports